import { createContext, useContext } from 'react';

import { ISelectOption } from '~/src/dash/components/dropdowns/common';

interface ITargetingPresetFormContext {
  lists: Record<string, ISelectOption[]>;
}

export const TargetingPresetFormContext = createContext({} as ITargetingPresetFormContext);
export const useTargetingPresetFormStore = (): ITargetingPresetFormContext =>
  useContext(TargetingPresetFormContext);
